import { api } from "@/lib/api";

export const REPORT_CATEGORIES = [
  ["harassment", "Harassment"], ["hate_abuse", "Hate or abusive content"], ["impersonation", "Impersonation"], ["spam", "Spam"],
  ["inappropriate_imagery", "Inappropriate imagery"], ["copyright", "Copyright or ownership concern"], ["fraud", "Fraudulent activity"],
  ["cheating", "Cheating or tournament misconduct"], ["other", "Other policy violation"],
];
export const RESTRICTION_FUNCTIONS = [["upload", "Uploading"], ["post", "Posting"], ["join", "Joining"], ["report", "Reporting"], ["host", "Hosting games/events"]];
export const label = (s) => (s || "").replaceAll("_", " ");
export const when = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

export async function uploadEvidence(files) {
  if (!files?.length) return [];
  const fd = new FormData();
  [...files].slice(0, 5).forEach((f) => fd.append("files", f));
  const r = await api.post("/uploads/images?kind=evidence", fd);
  return r.data.files.map((f) => f.file_id);
}
